import dbConnection from "../dbConnection";

const generalActions = {
  login: function (data: any) {
    return dbConnection.post("api/admin/login", data);
  },
  getOrganizations: function (type) {
    return dbConnection.get("api/admin/organization/org_type/" + type);
  },
  getOrgsGroupsFiltering: function () {
    // orgs_groups_filtering;
    return dbConnection.get("api/admin/organization/orgs_groups_filtering");
  },
  getOrgsWithAddress: function () {
    return dbConnection.get("api/admin/organization/orgs_with_address");
  },
  getSchools: function (accountType: string, raw: boolean) {
    return new Promise(function (resolve, reject) {
      dbConnection.get("api/admin/schools?v2=yes").then((response) => {
        if (raw) {
          resolve({ data: response.data });
        }
        const data = [];
        const councils = {};

        const schools = response.data.schools
          ? response.data.schools
          : response.data;
        schools.forEach((element) => {
          if (accountType == "SUPERADMIN") {
            const field =
              element.council_id == 0 ? "Independent" : element.council.name;
            if (!councils[field]) {
              councils[field] = {
                label: field,
                options: [],
                councilId: element.council_id,
              };
            }
            councils[field].options.push({
              label: element.name,
              value: element.id,
            });
          } else {
            data.push({
              label: element.name,
              value: element.id,
            });
          }
        });
        if (accountType == "SUPERADMIN") {
          const groups = response.data.groups;
          const groupsArray = groups.map((itm) => {
            return {
              label: itm.name,
              value: "group_" + itm.id,
              school_ids: itm.school_ids.split(","),
            };
          });
          data.push({
            label: "GROUPS ONLY",
            options: groupsArray,
          });
          data.push({
            label: "ALL",
            options: [
              {
                label: "ALL",
                value: "all",
              },
            ],
          });
          data.push({
            label: "COUNCILS ONLY",
            options: [],
          });
          Object.keys(councils).forEach((item) => {
            data.push(councils[item]);
            data[2].options.push({
              label: item,
              value: "council_" + councils[item].councilId,
            });
          });
        }
        // this.schools = data;
        // this.schools = response.data;
        resolve({ data });
      });
    });
  },
  getOrganization: function (id) {
    return dbConnection.get("api/admin/organization/view/" + id);
  },
  getAdminSchools: function () {
    return dbConnection.get("api/admin/schools?v2=yes");
  },
  getSchoolsAndCounts: function (id) {
    return dbConnection.get("api/council-admin/council/" + id + "/schools");
  },
  getSingleMessage: function (noticeId) {
    return dbConnection.get("api/admin/notification/viewNotice/" + noticeId);
  },
  getCouncils: function () {
    return dbConnection.get("api/admin/councils");
  },
  getTerms: function () {
    return dbConnection.get("api/admin/organization/terms");
  },

  getMarkers: function (payload) {
    return dbConnection.post("api/admin/dashboard/getUserAddresses", payload);
  },
  getUserGeofences: function (payload) {
    return dbConnection.post("api/admin/dashboard/getUserGeofences", payload);
  },
  getSchoolUsers: function () {
    return dbConnection.get("api/admin/school/students");
  },
  getSchoolStaff: function () {
    return dbConnection.get("api/admin/school/staff");
  },
  getSchoolParents: function () {
    return dbConnection.get("api/admin/school/parents");
  },
  getMainStats: function (payload) {
    return dbConnection.post("api/admin/dashboard/homeData", payload);
  },
  getEngagementStats: function (payload) {
    return dbConnection.post("api/admin/dashboard/engagement", payload);
  },
  getSignupData: function (payload) {
    return dbConnection.post("api/admin/dashboard/signups", payload);
  },
  getDashboardHome: function () {
    return dbConnection.get("api/admin/dashboard/dashboardHome");
  },

  saveComment: function (payload) {
    return dbConnection.post("api/admin/notification/comments/save", payload);
  },
  removeComment: function (id) {
    return dbConnection.post(
      "api/admin/users/comments/removeComment/" + id,
      {}
    );
  },
  getAdminMessages: function () {
    return dbConnection.get("api/admin/administration/getAdminMessages");
  },
  unreadAdminMessagesCount: function () {
    return dbConnection.get(
      "api/admin/administration/unreadAdminMessagesCount"
    );
  },
  setAdminMessageAsRead: function (messageId) {
    return dbConnection.get(
      "api/admin/administration/setAdminMessageAsRead/" + messageId
    );
  },
  getParentOrStudent: function (params) {
    return dbConnection.post("api/admin/actions/getParentOrStudent", params);
  },
  getOrgGroups: function (orgId, groupType) {
    return dbConnection.get(
      "api/admin/organization/groups/" + orgId + "/" + groupType
    );
  },
  allSchoolYears: function () {
    return dbConnection.get("api/admin/administration/allSchoolYears/");
  },
  getSchoolGroups: function () {
    return dbConnection.get("api/admin/administration/getSchoolGroups");
  },
  saveGroup: function (params) {
    return dbConnection.post("api/admin/administration/saveGroup", params);
  },
  storeStudentYears: function (params) {
    return dbConnection.post(
      "api/admin/organization/groups/storeStudentYears",
      params
    );
  },
  deleteGroup: function (params) {
    return dbConnection.post("api/admin/administration/deleteGroup", params);
  },
  saveNewNotice: function (send, params) {
    let extra = "";
    if (send) {
      extra = "?send=1";
    }
    return dbConnection.post(
      "api/admin/notification/sendNotifications" + extra,
      params
    );
  },
  saveNoticeOnly: function (params) {
    params.save = true;
    params.isTemplate = true;
    return dbConnection.post(
      "api/admin/notification/sendNotifications",
      params
    );
  },
  viewNoticeTemplate: function (id) {
    return dbConnection.get("api/admin/notification/viewNoticeTemplate/" + id);
  },
  getYears: function (accType, schoolIds) {
    let url = "";
    if (accType == "SCHOOL_ADMIN") {
      url = "api/school-admin/school-years";
    } else if (accType == "COUNCIL_ADMIN" || accType == 'MULTI_SCHOOL_ADMIN') {
      url = "api/council-admin/school-years";
    } else if (accType == "ADMIN") {
      url = "api/admin/school-years";
    }

    let params = {};
    if (typeof schoolIds != "undefined") {
      params = {
        params: {
          "schoolIds[]": schoolIds,
        },
      };
    }

    return new Promise(function (resolve, reject) {
      dbConnection.get(url, params).then((resp) => {
        const _returnYears = [];
        const _responseData = resp.data.years.sort((a, b) =>
          a.level < b.level ? 1 : -1
        );
        for (let i = _responseData.length; i--; ) {
          _returnYears.push({
            id: _responseData[i].level,
            name: _responseData[i].name,
          });
        }

        resolve(_returnYears);
      });
    });
  },
  saveSchool: function (payload) {
    return dbConnection.post("api/admin/school-creation/store", payload);
  },
  saveOrganization: function (payload) {
    return dbConnection.post("api/admin/organization/store", payload);
  },
  saveCouncilAsAdmin: function (payload) {
    return dbConnection.post("api/admin/councils", payload);
  },
  schoolYearLookup: function (schoolId: number) {
    return dbConnection.get(
      "api/admin/school-creation/" + schoolId + "/school-year-lookup"
    );
  },
  getDefaultYears: function () {
    return dbConnection.get(
      "api/admin/organization/groups/defaultStudentYears"
    );
  },
  getSchoolYears: function (schoolId: number) {
    return dbConnection.get(
      "api/admin/school-creation/" + schoolId + "/get-school-years"
    );
  },
  getSchoolAddresses: function (schoolId: number) {
    return dbConnection.get(
      "api/admin/school-creation/" + schoolId + "/get-school-addresses"
    );
  },
  getOrgAddresses: function (orgId: number) {
    return dbConnection.get("api/admin/organization/addresses/" + orgId);
  },
  getOrganizationAddresses: function (schoolId: number) {
    return dbConnection.get(
      "api/admin/organization/addresses/" + schoolId + ""
    );
  },
  getNoticeAudience(noticeId) {
    return dbConnection.get("api/admin/notification/audience/" + noticeId);
  },
  saveOrganizationAddress: function (payload) {
    return dbConnection.post("api/admin/organization/addresses/store", payload);
  },
  saveSchoolYears: function (payload) {
    return dbConnection.post(
      "api/admin/school-creation/" + payload.school_id + "/saveSchoolYears",
      payload
    );
  },
  updateAdminInfo: function (payload) {
    return dbConnection.post(
      "api/admin/administration/updateAdminInfo",
      payload
    );
  },
  refreshAdmin: function () {
    return dbConnection.post("api/admin/administration/refreshAdmin");
  },
  increaseSignupsInfo: function () {
    return dbConnection.get("api/increaseSignups");
  },
  deleteNotice: function (id: number) {
    return dbConnection.delete("api/admin/notification/delete/" + id);
  },
  getGeofences: function (payload) {
    return dbConnection.post("api/admin/dashboard/getGeofences", payload);
  },
  getHomeGeofences: function (payload) {
    return dbConnection.post("api/admin/dashboard/getHomeGeofences", payload);
  },
  getTravelFeatures: function (queryParams) {
    return dbConnection.get("api/admin/travel_features?" + queryParams);
  },
  saveTravelFeature: function (payload, queryParams) {
    if (payload.staffOnly && payload.parentOnly) {
      payload.staffOnly = 0;
      payload.parentOnly = 0;
    }
    return dbConnection.post(
      "api/admin/travel_features?" + queryParams,
      payload
    );
  },
  deleteTravelFeature: function (id: number) {
    return dbConnection.delete("api/admin/travel_features/" + id);
  },
  getAlerts: function () {
    return dbConnection.get("api/admin/alerts");
  },
  hideAlert: function (id: number) {
    return dbConnection.post("api/admin/alerts", { id });
  },
  isTermAgreed: function () {
    return dbConnection.get("api/admin/administration/isTermsAgreed");
  },
  hideTermsModal: function () {
    const payload = {
      tc_agreed: true
    }
    return dbConnection.post("api/admin/organization/settings", payload);
  },
  getOrganizationSettings: function () {
    return dbConnection.get("api/admin/organization/settings");
  },
  postOrganizationSettings: function (payload) {
    return dbConnection.post("api/admin/organization/settings", payload);
  },
};

export default generalActions;
